import React from 'react'

import Details from './details'
import ProfileSecurity from './profile-security'
import PurchasingSecurity from './purchasing-security'
import CommunicationSettings from './communication-settings'

function AccountDetails() {
  return (
    <>
      <Details />
      <ProfileSecurity />
      <PurchasingSecurity />
      <CommunicationSettings />
    </>
  )
}

export default AccountDetails
